import actions from './action'
import mutations from './mutation'
import state from './state'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}